import { HiredStagesAndFunnelName } from 'api-clients/monolith';
import { FormattedMessage } from 'react-intl';

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card';
import { Typography } from '@/components/ui/typography';

interface HireStagesHoverCardProps {
  applicantsHiredInStages: HiredStagesAndFunnelName[];
}

export function HireStagesHoverCard({
  applicantsHiredInStages,
}: HireStagesHoverCardProps) {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Typography variant="link1" className="!no-underline">
          <FormattedMessage
            defaultMessage="{count} stages"
            values={{ count: applicantsHiredInStages.length }}
          />
        </Typography>
      </HoverCardTrigger>
      <HoverCardContent align="start" className="max-w-80 w-fit">
        <div className="flex flex-col items-start justify-center">
          {applicantsHiredInStages.map(stage => (
            <div
              key={stage.stage_name}
              className="flex items-center gap-1 py-1.5"
            >
              <Typography variant="body1" className="!text-fx-neutral-600">
                {stage.stage_name}
              </Typography>
              <Typography variant="body1" className="!text-fx-neutral-400">
                {`(${stage.funnel_name})`}
              </Typography>
            </div>
          ))}
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
